import styled from 'styled-components';

export const CenteredMessage = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  .icon {
    display: block;
    margin: 0.5rem auto;
  }
  a {
    text-decoration: none;
  }
`;
